import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="-1 -1 50 50">
    <path
      fill="none"
      stroke="#0EB87F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M35 8h12M41 2v12"
    />
    <path
      fill="none"
      stroke="#0EB87F"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M23.8 22.6H23c-2.7.5-4.4-.5-5.9-3-.9 1.7-3.7 3-6 3-1.1 0-2.1-.3-3-.8.7-4.4 4-7.8 7.9-7.8 4.1 0 7.5 3.8 7.8 8.6z"
    />
    <path
      fill="#E4F7F1"
      stroke="#0EB87F"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M23.9 23.5c0 5.2-3.5 9.5-7.9 9.5s-7.9-4.2-7.9-9.5c0-.5 0-1 .1-1.5.9.5 2 .8 3 .8 2.3 0 5.1-1.4 6-3 1.5 2.6 3.2 3.6 5.9 3 .3-.1.5 0 .8 0v.7z"
    />
    <path
      fill="none"
      stroke="#0EB87F"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M8.2 21.9s-.1 0 0 0M29 14c4.4 0 7.9 4.2 7.9 9.5 0 5.2-3.5 9.5-7.9 9.5"
    />
    <path
      fill="none"
      stroke="#0EB87F"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M36.8 22.6c-.3 0-.5 0-.7.1-2.7.5-4.4-.5-5.9-3"
    />
    <path
      fill="none"
      stroke="#0EB87F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M37.1 46H44v-3c0-2-1.2-3.8-3.1-4.5L33 35.7v-4.1M12 31.6v4.1l-7.9 2.8C2.2 39.2 1 41 1 43v3h5M12 46h19v-3c0-2-1.2-3.8-3.1-4.5L20 35.7v-4.1"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/onboarding-add-user.es6.js